// extracted by mini-css-extract-plugin
export default {"column":"table_column__Dpxus","wrap":"table_wrap__7hyXk","row":"table_row__kSUEB","rowWrap":"table_rowWrap__ho2ML","label":"table_label__lPpwB"};